import { render, staticRenderFns } from "./cityArea.vue?vue&type=template&id=65be7bf7&scoped=true"
import script from "./cityArea.vue?vue&type=script&lang=js"
export * from "./cityArea.vue?vue&type=script&lang=js"
import style0 from "./cityArea.vue?vue&type=style&index=0&id=65be7bf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65be7bf7",
  null
  
)

export default component.exports